export default "__VITE_ASSET__pnF0stpv__"